import React from 'react';
import { WithClassname } from '../../types';
import { StoreDetails } from '../../types/store';
import { GoogleMap, Marker } from '@react-google-maps/api';
import classnames from 'classnames';
import DeliveryZone from './DeliveryZone';

type Props = WithClassname & {
  data: StoreDetails;
};

export default function StoreDeliveryInfo({ data, className }: Props) {
  return (
    <GoogleMap
      mapContainerClassName={classnames('h-full w-full', className)}
      center={{
        lat: data.location.lat,
        lng: data.location.lng,
      }}
      zoom={12}
      options={{
        mapTypeControl: false,
        streetViewControl: false,
      }}
    >
      <Marker
        label={data.name}
        position={{
          lat: data.location.lat,
          lng: data.location.lng,
        }}
      />
      {data.order_settings.delivery_zones.map((item) => (
        <DeliveryZone data={item} key={`delivery-zone-${item?.id}`} />
      ))}
    </GoogleMap>
  );
}
